import { graphql, useStaticQuery } from "gatsby";
import { get } from "lodash";
import React, { useState } from "react";
import styled from "styled-components";
import { ACSS, theme } from "@upsolve/ui";

import ImageInContext from "../Media/ImageInContext";
import Mask from "../Media/Mask.div";
import getMyUpsolveEntryUrl from "../Links/getMyUpsolveEntryUrl";
import { MyUpsolveButtonLink } from "../Links/MyUpsolveLink";
import withViewportWatch from "../analytics/withViewportWatch";
import trackComponentImpression from "../analytics/trackComponentImpression";
import trackComponentAction from "../analytics/trackComponentAction";

const trackingProps = {
  componentName: "CTATestimonial",
  componentVersion: 0,
};

const CTATestimonial = (props) => {
  const data = useStaticQuery(graphql`
    query TestimonialCTAQuery {
      contentfulFreshStartDiary(filerName: { eq: "Denise Smith" }) {
        slug
        filerName
        caseFiled
        storyQuote {
          storyQuote
        }
        filerImage {
          ...ImageNode
        }
      }
    }
  `);
  // Tracking
  const [impressionTracked, setImpressionTracked] = useState(false);
  if (props.isInViewport && !impressionTracked) {
    setImpressionTracked(true);
    props.stopWatcher();
    trackComponentImpression(trackingProps);
  }

  // Comp
  return (
    <TestimonialWrapper dataTestId={props.dataTestId}>
      <div className="text-wrapper">
        <span className="label">Fresh Start Diaries</span>
        <div className={`quote ${data.contentfulFreshStartDiary.storyQuote.storyQuote.length > 80 ? "condensed" : ""}`}>
          "{data.contentfulFreshStartDiary.storyQuote.storyQuote.trim()}"
          <br />
          <small>
            <u>
              <a aria-busy="false" href={`/fresh-starts/${data.contentfulFreshStartDiary.slug}/`}>
                I filed with Upsolve. Read my story →
              </a>
            </u>
          </small>
        </div>
        <div className="actions">
          <MyUpsolveButtonLink
            aria-busy="false"
            inverted
            href={getMyUpsolveEntryUrl({
              triggeredByActionId: "ctaTestimonial.myUpsolveNavigation",
              contentGroup: props.contentGroup,
            })}
            onClick={() =>
              trackComponentAction({
                ...trackingProps,
                actionId: "ctaTestimonial.myUpsolveNavigation",
                actionMethod: "click",
              })
            }
          >
            Get Free Bankruptcy Help
          </MyUpsolveButtonLink>
        </div>
      </div>
      <div className="filer-image">
        <Mask side="left">
          <ImageInContext
            alt={get(data.contentfulFreshStartDiary, "filerImage.altText")}
            src={get(data.contentfulFreshStartDiary, "filerImage.image.file.url")}
            fluid={get(data.contentfulFreshStartDiary, "filerImage.image.fluid")}
          />
        </Mask>
      </div>
    </TestimonialWrapper>
  );
};

const TestimonialWrapper = styled.div.attrs((props) => ({
  "data-test-id": props.dataTestId,
}))`
  display: flex;
  border-radius: 8px;
  box-shadow: inset 0 0 0 1px ${theme.colors.white["500"]}, 0 5px 15px -5px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  @media (max-width: 45em) {
    flex-direction: column-reverse;
  }
  .text-wrapper {
    flex-grow: 1;
    padding: 2em;
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    a {
      ${ACSS}
    }
    .label {
      margin: 0;
      color: ${theme.colors.white["100"]};
      font-weight: 500;
      font-size: 0.9em;
    }
    .quote {
      color: ${theme.colors.brand["500"]};
      font-size: 1.4em;
      line-height: 1.5em;
      font-weight: 700;
      margin: 1em 0 2em;
      &.condensed {
        font-size: 1.25em;
      }
    }
    .actions {
      display: flex;
      align-items: center;
    }
    @media (max-width: 45em) {
      width: 100%;
      .label {
        text-align: center;
      }
      .actions a {
        width: 100%;
      }
    }
  }
  .filer-image {
    width: 40%;
    max-height: 100%;
    div > img {
      max-width: 100%;
    }
    @media (max-width: 45em) {
      width: 100%;
      height: 400px;
      overflow: hidden;
      display: none;
    }
  }
`;

export default withViewportWatch(CTATestimonial);
